import { pick } from 'lodash'

const ingredientSimpleDetailsFormInitialValues = allergen =>
  pick(allergen, ['description', 'position', 'isExcludedFromSearch'])

export default ingredientSimpleDetailsFormInitialValues
